import { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import type { DataTableFilter } from "~components/DataTable/types/dataTableFilter.ts";
import FilterSelectFixtureStatus from "~components/FilterSelectFixtureStatus/FilterSelectFixtureStatus.tsx";
import { TableFilter } from "~enums/tableFilter.ts";
import { FixturePlayByPlayEventFilters } from "~pages/Reports/components/FixturePlayByPlayFlaggedEventDataTable/enums/FixturePlayByPlayEventFilters.ts";

export const useGetFixturePlayByPlayFlaggedEventDataTableFilters = (
  defaultFilter: Record<string, any> = {},
): {
  filters: DataTableFilter[];
  currentFilter: Record<string, any>;
  handleFilterChange: (updatedFilter: Record<string, any>) => void;
} => {
  const [currentFilter, setCurrentFilter] = useState<Record<string, any>>(defaultFilter);
  const { formatMessage } = useIntl();

  const handleFilterChange = useCallback((updatedFilter: Record<string, any>) => {
    setCurrentFilter(updatedFilter);
  }, []);

  const filters = [
    {
      filterKey: FixturePlayByPlayEventFilters.FixtureStatus,
      tableFilterType: TableFilter.Primary,
      filterElement: (props: { value: any; onChange: (value: any) => void }) => (
        <FilterSelectFixtureStatus
          onChange={props.onChange}
          multiple
          width={200}
          value={props.value}
          placeholder={formatMessage({
            id: "dataTable.filters.fixtuerStatus.allOption",
          })}
        />
      ),
    },
  ];

  return {
    filters,
    currentFilter,
    handleFilterChange,
  };
};
